var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"beat-clock",class:_vm.getThemeClass()},[_c('span',{staticClass:"symbol"},[_vm._v("@")]),_c('div',{staticClass:"beats-list"},[_c('span',[_vm._v("\n            "+_vm._s(_vm.beatTime)+"\n        ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }